import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { clearOfflineCache } from "@/lib/pwa";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("crm_token")) return setUser(false);
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = async (email, password, portal = "crm") => {
    const { data } = await api.post("/auth/login", { email, password, portal });
    localStorage.setItem("crm_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("crm_token");
    await clearOfflineCache();
    setUser(false);
  };

  const isManager = user && ["ADMIN", "SALES_MANAGER"].includes(user.role);
  return <AuthCtx.Provider value={{ user, login, logout, isManager }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
